import { DefaultUrlSerializer, UrlTree } from '@angular/router';

/**
 * URL del QR masivo: /pl-aa/{country}/{planId}/{codigo}. El codigo es base64 y puede traer '/', '+'
 * y '='. Con dos '/' seguidos (un codigo que empieza con '/') Angular corta la URL y la pagina da 404.
 *
 * Antes de parsear se codifica el codigo como un solo segmento ('/' -> %2F), asi llega completo a la
 * pagina del QR. Cualquier otra URL pasa sin cambios por el serializador por defecto.
 */
export class AssignmentCodeUrlSerializer extends DefaultUrlSerializer {

    private static readonly ASSIGNMENT_CODE_URL = /^\/pl-aa\/([^/?#]+)\/([^/?#]+)\/([^?#]+)(.*)$/;

    override parse(url: string): UrlTree {

        const match = AssignmentCodeUrlSerializer.ASSIGNMENT_CODE_URL.exec(url);

        if (match) {

            // Puede venir ya codificado (al recargar, Angular lo escribe con %2F): se decodifica primero
            let code = match[3];
            try {
                code = decodeURIComponent(code);
            } catch {
                // Si no se puede decodificar se usa tal cual
            }

            url = `/pl-aa/${match[1]}/${match[2]}/${encodeURIComponent(code)}${match[4]}`;
        }

        return super.parse(url);
    }
}
